import { GzDashboardFeedBackDialogContentWebComponent } from './component/GzDashboardFeedBackDialogContentWebComponent';

export { GzDashboardFeedBackDialogContentWebComponent };
